
// import { defineComponent, defineAsyncComponent } from "vue";
// const AsyncComponents = defineAsyncComponent(
//     () => import("./componets/AsyncComponnets.vue")
// );
import { defineComponent } from "vue";
import AsyncComponents from './componets/AsyncComponnets.vue';
export default defineComponent({
    name: 'App',
    components: {
        AsyncComponents,
    },
    setup() {
        return {
        }
    }
});
